import * as React from 'react';

import { Routes, Route } from 'react-router-dom';

import RequireAuth from '../../components/RequireAuth';

import { useAppData } from '../../core/context/AppDataContext';
import { ReportType } from '../../core/api/clients';
import { AuthorizedFormDataProvider } from '../../core/context/AuthorizedFormDataContext';

import LoadingOverlay from '../../components/LoadingOverlay';

import FlightEventHome from './FlightEventHome';
import FlightEventFormLayout from './FlightEventFormLayout';
import FlightEventFormEdit from './FlightEventFormEdit';
import FlightEventFormNew from './FlightEventFormNew';
import FlightEventFormView from './FlightEventFormView';
import useTitle from '../../core/api/hooks/common/useTitle';

function FlightEventContainer() {
  const { authorizedForms, getFormByName } = useAppData();
  useTitle(document.documentURI);
  if (authorizedForms !== undefined) {
    const form = getFormByName(ReportType.FlightEventReport);

    if (form !== undefined) {
      const { isContributor, isAdministrator, isReader, isApprover } = form;

      const canEdit = (isContributor || isApprover || isAdministrator);
      const canView = (isReader || canEdit);

      return (
        <AuthorizedFormDataProvider authorizedFormData={form}>
          <Routes>
            <Route path=":formId" element={<FlightEventFormLayout />}>
              <Route
                path="edit"
                element={(
                  <RequireAuth isAuthorized={canEdit ?? false}>
                    <FlightEventFormEdit />
                  </RequireAuth>
                )}
              />
              <Route
                path=":action"
                element={(
                  <RequireAuth
                    isAuthorized={canView ?? false}
                  >
                    <FlightEventFormView />
                  </RequireAuth>
                )}
              />
            </Route>
            <Route
              path="new"
              element={(
                <RequireAuth isAuthorized={form.isContributor ?? false}>
                  <FlightEventFormNew />
                </RequireAuth>
              )}
            />
            <Route
              index
              element={(
                <FlightEventHome />
              )}
            />
          </Routes>
        </AuthorizedFormDataProvider>
      );
    }

    return (
      <span>Not Authorized</span>
    );
  }

  return (
    <LoadingOverlay />
  );
}

export default FlightEventContainer;
